import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import color from 'color';
import BLOBS_THUMB_IMAGE_URL from '../../../assets/backgrounds/thumb-blobs.png';
import BLOBS_2_THUMB_IMAGE_URL from '../../../assets/backgrounds/thumb-blobs2.png';
import BLOBS_3_THUMB_IMAGE_URL from '../../../assets/backgrounds/thumb-blobs3.png';
import BEER_BUTTON_IMAGE_URL from '../../../assets/bombButtons/beer-button.png';
import BOMB_BUTTON_IMAGE_URL from '../../../assets/bombButtons/bomb-button.png';
import HEART_BUTTON_IMAGE_URL from '../../../assets/bombButtons/heart-button.png';
import PIE_BUTTON_IMAGE_URL from '../../../assets/bombButtons/pie-button.png';
import SHEEP_BUTTON_IMAGE_URL from '../../../assets/bombButtons/sheep-button.png';
import PLAY_STYLE_IMAGE_URL from '../../../assets/gameGuide/play-style.png';
import RABBITS_IMAGE_URL from '../../../assets/gameGuide/rabbits.png';
import ACTIVE_PLAYER_HALOS_IMAGE_URL from '../../../assets/newsItems/active-player-halos.png';
import AVATAR_SHADING_IMAGE_URL from '../../../assets/newsItems/avatar-shading-and-lipstick.png';
import BG_ART_DECO_IMAGE_URL from '../../../assets/newsItems/bg-art-deco.gif';
import BG_MOON_IMAGE_URL from '../../../assets/newsItems/bg-moon.gif';
import BG_TRUCHET_IMAGE_URL from '../../../assets/newsItems/bg-truchet.gif';
import BG_WOOD_IMAGE_URL from '../../../assets/newsItems/bg-wood.gif';
import BG_ZIGZAG_IMAGE_URL from '../../../assets/newsItems/bg-zigzag.gif';
import BOMBS_IMAGE_URL from '../../../assets/newsItems/bombs.png';
import CHAT_BUBBLE_IMAGE_URL from '../../../assets/newsItems/chat-bubble.png';
import HAND_REVEALING_IMAGE_URL from '../../../assets/newsItems/hand-revealing.png';
import LIZARD_AVATAR_THUMB_IMAGE_URL from '../../../assets/newsItems/lizard-avatar-thumb.webp';
import MONKEY_AVATAR_THUMB_IMAGE_URL from '../../../assets/newsItems/monkey-avatar-thumb.webp';
import QUEEN_AVATAR_THUMB_IMAGE_URL from '../../../assets/newsItems/queen-avatar-thumb.webp';
import SENTINEL_AVATAR_THUMB_IMAGE_URL from '../../../assets/newsItems/sentinel-avatar-thumb.webp';
import WINNING_HAND_NAME_IMAGE_URL from '../../../assets/newsItems/winning-hand-name.png';
import WIZARD_AVATAR_THUMB_IMAGE_URL from '../../../assets/newsItems/wizard-avatar-thumb.webp';
import { EmphasisContainer } from '../../../components/emphasisContainer';
import { TWITTER_ACCOUNT_URL } from '../../../constants/constants';
import { YELLOW_COLOR } from '../../../styles/colors';
import { ALL_THEME_BACKGROUND_PROPERTIES } from '../../../types/themeBackgroundTypes';
import { ALL_THEME_TABLE_PROPERTIES } from '../../../types/themeTableTypes';
import { isTestEnvironment, md5 } from '../../../utils/utils';
import { NewsImageDisplay } from './newsImageDisplay';
import { RandomizingList } from './randomizingList';
import { TableThemeNewsDisplay } from './tableThemeNewsDisplay';
export function getNewsItemHash(newsItem) {
    const parts = [newsItem.dateString];
    if (newsItem.title) {
        parts.push(newsItem.title);
    }
    if (newsItem.description) {
        parts.push(newsItem.description);
    }
    return md5(parts.join(' - '));
}
export function getNewsItems() {
    if (isTestEnvironment()) {
        // by default, don't render any news items in tests
        const params = new URLSearchParams(window.location.search);
        if (params.has('mockNewsItems')) {
            return JSON.parse(params.get('mockNewsItems') || '[]');
        }
        return [];
    }
    return NEWS_ITEMS;
}
const NEWS_ITEMS = [
    {
        dateString: 'Dec 31, 2020',
        title: 'Goodbye 2020!',
        items: ['The EARLY BETA of the new Triplejack for web and mobile launches!']
    },
    {
        dateString: 'Jan 1, 2021',
        title: 'HAPPY NEW YEAR!',
        items: ['Added ability to activate / extend Power Player status.']
    },
    {
        dateString: 'Jan 3, 2021',
        title: 'Game sounds added!',
        items: ['The majority of the game sounds have been added.', 'Mute / unmute button added to menu.']
    },
    {
        dateString: 'Jan 3, 2021',
        title: 'Games that require Jacks to play can now be joined!'
    },
    {
        dateString: 'Jan 4, 2021',
        items: [
            'Added room summaries, such as the list of players, to the lobby.',
            'Clickable links in chat panels are now supported.'
        ]
    },
    {
        dateString: 'Jan 5, 2021',
        items: [
            'Jacks games now supported.',
            'Card display sizes adjusted slightly.',
            'Panels show a close icon on hover on desktop, or always on mobile.',
            "The 'page unload' alert will no longer show if you've been disconnected."
        ]
    },
    {
        dateString: 'Jan 7, 2021',
        items: [
            'Tourney blind timer moved into the table area, and now shows number of remaining MTT tables.',
            'Avatar outline effect shown on hover.'
        ]
    },
    {
        dateString: 'Jan 8, 2021',
        items: [
            'Chat panel button shows an indicator when there is unread player chat.',
            'Sound plays when a player chat message arrives.',
            'On mobile, poker rooms start with the panel closed.'
        ]
    },
    {
        dateString: 'Jan 12, 2021',
        title: 'New Avatar System!',
        items: [
            'New customizable avatar system is available now. Access it in the Self Panel in a poker room!',
            'Added display of next automated tourney in the lobby, with a timer.'
        ]
    },
    {
        dateString: 'Jan 14, 2021',
        title: 'HTTPS Support!',
        items: [
            _jsxs(_Fragment, { children: ["You can now connect to the game and play over an HTTPS (secure) connection at", ' ', _jsx("a", { href: 'https://www.triplejack.com/poker/', children: "https://www.triplejack.com/poker/" }), "."] }),
            'Avatar now shown on floating display to stay visible while scrolling options.',
            "'Loading' shown while avatars are being loaded."
        ]
    },
    {
        dateString: 'Jan 17, 2021',
        items: [
            'You can see a list of medals earned by yourself (on the self panel) or other players (when clicking to view their info).',
            'You can view your player avatar (on the self panel) or other player avatars (when clicking to view their info) in any room type.',
            'New focused menu of actions appears when clicking on your seated player.',
            'Avatar color options expanded.'
        ]
    },
    {
        dateString: 'Jan 19, 2021',
        title: 'All new card art!'
    },
    {
        dateString: 'Jan 23, 2021',
        title: 'Current tourney standings (chip counts) are shown on a new panel while playing an MTT!'
    },
    {
        dateString: 'Jan 25, 2021',
        items: [
            'Seated player status for chips, all-in state, or sitting-out state are consolidated into one display below the name.',
            'Added a mechanism to stop your mobile device from going to sleep once you start playing.',
            'Player names and chips are dimmed when not in the hand.'
        ]
    },
    {
        dateString: 'Jan 29, 2021',
        title: 'The self panel now shows your tournament tickets.'
    },
    {
        dateString: 'Jan 31, 2021',
        items: [
            'Improved sharpness of text for seated players, chips, bets, and pots.',
            "Fix: When a player in a showdown stands up, it will now show 'Standing Up' instead of 'ALL-IN'.",
            "Added spinner animations to the 'Login' and 'Sign Up' buttons.",
            'Rooms in lobby have a simpler, flat look.'
        ]
    },
    {
        dateString: 'Feb 2, 2021',
        items: [
            'Your hole cards are now shown through the end of the hand, even if you folded.',
            'A gradient backdrop is now shown behind your cards and controls while playing.',
            'Button appearances improved slightly.'
        ]
    },
    {
        dateString: 'Feb 6, 2021',
        items: [
            'You can now auto check / auto fold before the action gets to you!',
            'When hole cards and community cards appear, there is a brief glowing animation!',
            'Button text looks better now!'
        ]
    },
    {
        dateString: 'Feb 8, 2021',
        title: 'Tourney calendar added to menu!'
    },
    {
        dateString: 'Feb 9, 2021',
        title: 'You can now give Jacks to other players!'
    },
    {
        dateString: 'Feb 13, 2021',
        title: 'Added a new Settings modal with the Auto Reload Buy-in setting (available to Power Players)!'
    },
    {
        dateString: 'Feb 14, 2021',
        title: 'Added Four-Color Deck setting (available to Power Players)!'
    },
    {
        dateString: 'Feb 19, 2021',
        items: [
            'Lobby panels can be closed entirely, and are off initially on mobile devices.',
            'Simplified sound on/off button.',
            'New iOS Home Screen icon.'
        ]
    },
    {
        dateString: 'Feb 23, 2021',
        title: 'Hand History Panel added (available to Power Players)!'
    },
    {
        dateString: 'Feb 25, 2021',
        title: 'Avatar art updates!',
        items: [
            'Avatar heads now look better, with added shading and depth.',
            "Started adding avatar part 'sub-types', the first one being a lipstick variation on mouths."
        ],
        content: _jsx(NewsImageDisplay, { src: AVATAR_SHADING_IMAGE_URL, withBorder: false })
    },
    {
        dateString: 'Feb 27, 2021',
        title: 'An obvious halo is now shown behind players still in the hand!',
        content: _jsx(NewsImageDisplay, { src: ACTIVE_PLAYER_HALOS_IMAGE_URL })
    },
    {
        dateString: 'Mar 1, 2021',
        title: 'Improvements made to performance, which you may notice on a slower or older device!'
    },
    {
        dateString: 'Mar 7, 2021',
        title: 'You can now throw pies at other players! More bomb types to follow...'
    },
    {
        dateString: 'Mar 11, 2021',
        title: 'Added pies, the "cartoon" bomb, and when players get hit, they bounce around a bit!',
        content: (_jsxs(_Fragment, { children: [_jsxs("div", { children: [_jsx(NewsImageDisplay, { src: PIE_BUTTON_IMAGE_URL, maxWidthStyle: '75px', withBorder: false }), _jsx(NewsImageDisplay, { src: BOMB_BUTTON_IMAGE_URL, maxWidthStyle: '75px', withBorder: false })] }), _jsx("div", { children: _jsx(NewsImageDisplay, { src: BOMBS_IMAGE_URL, maxWidthStyle: '350px' }) })] }))
    },
    {
        dateString: 'Mar 14, 2021',
        title: 'Log Out button added to menu.'
    },
    {
        dateString: 'Mar 16, 2021',
        title: 'Player info and self panels organized into collapsible sections.'
    },
    {
        dateString: 'Mar 22, 2021',
        title: 'Updates!',
        items: [
            'Beer bomb added!',
            'You can now bomb yourself, which might make you feel better after making a bad decision!',
            "New player 'sit' animation."
        ],
        content: _jsx(NewsImageDisplay, { src: BEER_BUTTON_IMAGE_URL, maxWidthStyle: '75px', withBorder: false })
    },
    {
        dateString: 'Apr 2, 2021',
        title: 'Friends Panel Updates!',
        items: [
            "You can now see your full list of friends (whether online or not) by expanding the 'ALL' section!",
            'Viewing player info now shows whether you are friends, and give options for managing that friendship.',
            'All friends list sections can be collapsed or expanded.'
        ]
    },
    {
        dateString: 'Apr 3, 2021',
        title: 'Hand Revealing Feature!',
        items: [
            'Show your bluff or huge hand you would have had!',
            'Click your hole cards after you have folded, or if the showdown is already happening to reveal.',
            'Your revealed hand will also appear in the Chat panel.',
            'The cost to reveal is 25 Jacks.'
        ],
        content: _jsx(NewsImageDisplay, { src: HAND_REVEALING_IMAGE_URL })
    },
    {
        dateString: 'Apr 5, 2021',
        title: 'Updates!',
        items: [
            "A little 'hop' animation happens whenever a player checks, bets, calls, or raises!",
            "A player 'bubble' with the text 'RELOADED!' appears when someone auto-reloads their chips.",
            'The left-side menu is now organized into expandable sections.',
            "A 'News' button can be found in the left-side menu."
        ]
    },
    {
        dateString: 'Apr 11, 2021',
        title: 'UI Improvements!',
        items: [
            'The name of the winning hand is clearly shown at showdown.',
            'The bottom-center seat has moved to the top-center position.',
            'Pots and side pots are now shown below the community cards.',
            'Tourney blind timer moved to the upper-left corner, and number of MTT tables moved to the upper-right.'
        ],
        content: _jsx(NewsImageDisplay, { src: WINNING_HAND_NAME_IMAGE_URL })
    },
    {
        dateString: 'Apr 15, 2021',
        title: 'You can now find a Triplejack player by name using the new button in the menu!'
    },
    {
        dateString: 'Apr 29, 2021',
        title: 'Heart charm added!',
        items: ['You can also use bombs/charms without first sitting down!'],
        content: _jsx(NewsImageDisplay, { src: HEART_BUTTON_IMAGE_URL, maxWidthStyle: '75px', withBorder: false })
    },
    {
        dateString: 'May 24, 2021',
        title: 'Customizable table and background!',
        items: ['Power Players can now edit the theme of the game!', 'Change the background image and table color.'],
        content: (_jsxs("div", { css: css `
          display: flex;
          flex-flow: row wrap;
        `, children: [_jsx(TableThemeNewsDisplay, { backgroundImagePath: ALL_THEME_BACKGROUND_PROPERTIES.paisley.imageUrl, themeTableProperties: ALL_THEME_TABLE_PROPERTIES.blue }), _jsx(TableThemeNewsDisplay, { backgroundImagePath: ALL_THEME_BACKGROUND_PROPERTIES.concentric.imageUrl, themeTableProperties: ALL_THEME_TABLE_PROPERTIES.darkGray }), _jsx(TableThemeNewsDisplay, { backgroundImagePath: ALL_THEME_BACKGROUND_PROPERTIES.squares.imageUrl, themeTableProperties: ALL_THEME_TABLE_PROPERTIES.purple }), _jsx(TableThemeNewsDisplay, { backgroundImagePath: ALL_THEME_BACKGROUND_PROPERTIES.olives.imageUrl, themeTableProperties: ALL_THEME_TABLE_PROPERTIES.green })] }))
    },
    {
        dateString: 'May 27, 2021',
        title: 'You can now set the number of seats when creating a regular game!'
    },
    {
        dateString: 'May 31, 2021',
        title: 'Initial Game Info pages have been added, providing documentation and help about the game!'
    },
    {
        dateString: 'June 13, 2021',
        title: 'Updated front page screenshots and added more Game Info pages.'
    },
    {
        dateString: 'July 11, 2021',
        title: 'Updates!',
        items: [
            'Free chip rebuy controls (and current bank) are now shown in the Self panel, Account modal, and drawer menu!',
            'Custom medals are now shown in Self panel and Player Info panels (including Monthly Champs medal)!',
            'Old Timer medal now shows in Self panel and Player Info panels!'
        ]
    },
    {
        dateString: 'August 10, 2021',
        title: 'Updates!',
        items: [
            'Change Email feature added to Account modal.',
            'Email Notifications can be toggled on or off in Settings.',
            'Jack icon added to menu button.',
            'Added a progress bar to the loading scene.'
        ]
    },
    {
        dateString: 'September 1, 2021',
        title: 'Player blocking has been added. Block chat and/or messages from specific players!'
    },
    {
        dateString: 'Fall 2022',
        title: 'Ramping back up development!',
        items: [
            'Added new table graphics, replacing the boring solid color ones.',
            'Improved appearance of active timer bar and username.',
            'Changed to a better font throughout the game!',
            'Performance improvements, particularly on mobile browsers.',
            'Converted to webpack bundler and reduced JS bundle size by ~40%!'
        ]
    },
    {
        dateString: 'November 16, 2022',
        title: 'Recent message conversations are now loaded when opening the messages tab! Much easier to get back to a previous conversation.'
    },
    {
        dateString: 'November 18, 2022',
        title: 'More message panel improvements! There is now a separate view for your recent conversations, and when you click one, that conversation fills the whole panel.'
    },
    {
        dateString: 'November 19, 2022',
        title: 'Graphics Updates!',
        items: [
            'Blinking animation added to winning player.',
            'Improved spotlight on players who are in the hand.',
            'Added drop shadows to avatars.',
            'Increased size of avatars a bit.'
        ]
    },
    {
        dateString: 'November 21, 2022',
        title: 'More Graphics Updates!',
        items: [
            'Power Player badge shows on seated players!',
            'Layout of seated player changed -- username is shown at the bottom, with chips on the right.'
        ]
    },
    {
        dateString: 'November 27, 2022',
        title: 'Aggro Betting Filter!',
        description: "This room setting for Regular (non-Tourney) Texas Hold 'Em games reduces the amount of all-in play on the table. When this setting is on, players who repeatedly make huge overbets will be warned, and if it continues, will be banned (from that room only). For players who want a more strategic game with more post-flop play, this setting is for you! (Formerly known as the 'Abusive' Betting Filter.)"
    },
    {
        dateString: 'December 8, 2022',
        title: 'Buy-in Ranges!',
        description: 'Regular (non-Tourney) games now have a setting that allows a range of buy-ins. When enabled, players can choose how many chips to sit and play with (as long as it is within the specified range) and whether to remember and automatically use that same amount each time they sit in that room!'
    },
    {
        dateString: 'December 15, 2022',
        title: 'Emoji Set Added! 😀🐔🙈👍💯',
        description: 'Say goodbye to the old pixelated emojis from the Flash era, Triplejack now uses open source Twitter emojis.'
    },
    {
        dateString: 'December 27, 2022',
        title: 'Crazy Pineapple 🍍 is here!',
        description: "Ready for a crazy poker variant? In Crazy Pineapple, you are dealt three hole cards, and after the flop betting round, you discard one card. Otherwise, it plays exactly like Texas Hold 'Em! As an extra-crazy twist, if there is an all-in reveal before the discard phase, players can see everyones' three hole cards before choosing what to discard. This gives players more information and ups the skill level!"
    },
    {
        dateString: 'January 1, 2023',
        title: "HAPPY NEW YEAR! 🎉 Let's play MIXED GAMES!",
        description: "Rooms that play mixed games will cycle through all poker variants: Hold 'Em, Omaha, and Crazy Pineapple! In tournaments, the variant is changed when the blinds go up. In regular games, the variant changes every 5 minutes."
    },
    {
        dateString: 'January 11, 2023',
        title: 'More table colors and better graphics!',
        description: 'Power Players now have TWELVE poker table color options to choose from (available in Settings), and the table graphics are improved!',
        content: (_jsx("div", { css: css `
          display: flex;
          flex-flow: row wrap;
          gap: 3px;
        `, children: Object.values(ALL_THEME_TABLE_PROPERTIES).map(({ tableFeltColorNum, label }, i) => (_jsx("div", { title: label, css: css `
              border: 3px solid black;
              width: 40px;
              height: 40px;
              background-color: ${color(tableFeltColorNum).string()};
            ` }, i))) }))
    },
    {
        dateString: 'January 14, 2023',
        title: 'New room backgrounds!',
        description: 'Power Players now have SIXTEEN different room backgrounds to choose from, including: wood, outer space, moon craters, art deco, concrete, truchet, and more!',
        content: (_jsxs("div", { css: css `
          display: flex;
          flex-flow: row wrap;
          gap: 3px;
          img {
            border: 3px solid black;
          }
        `, children: [_jsx("img", { src: BG_WOOD_IMAGE_URL, width: 100, height: 100, alt: 'Wood Background' }), _jsx("img", { src: BG_ART_DECO_IMAGE_URL, width: 100, height: 100, alt: 'Art Deco Background' }), _jsx("img", { src: BG_MOON_IMAGE_URL, width: 100, height: 100, alt: 'Moon Background' }), _jsx("img", { src: BG_ZIGZAG_IMAGE_URL, width: 100, height: 100, alt: 'Zig-Zag Background' }), _jsx("img", { src: BG_TRUCHET_IMAGE_URL, width: 100, height: 100, alt: 'Truchet Background' })] }))
    },
    {
        dateString: 'January 18, 2023',
        title: 'Power Players automatically "Rabbit Hunt", showing the cards that would have come after everyone folds!',
        content: (_jsx("img", { css: css `
          border: 2px solid black;
        `, src: RABBITS_IMAGE_URL, alt: 'Rabbits', width: 299, height: 105 }))
    },
    {
        dateString: 'January 19, 2023',
        title: 'Updates!',
        items: [
            'Subtle card rotation animation added to new hole cards and new community cards!',
            'Improved Power Player medals and icons!',
            'Optimized the file sizes of much of the art for faster load times!'
        ]
    },
    {
        dateString: 'January 22, 2023',
        title: "Avatar 'Randomize All' button now has more variety and sets colors as well!"
    },
    {
        dateString: 'January 25, 2023',
        title: 'Revamped the front page because it needed to be vamped again.'
    },
    {
        dateString: 'January 29, 2023',
        title: 'Converted the "Set Buy-in" modal to use a draggable slider instead of a text field.'
    },
    {
        dateString: 'February 9, 2023',
        title: 'Bye-Bye Banking!',
        description: 'Since the early days of Triplejack, whenever you stood up from the table and then sat again, it would use the normal buy-in for your "rebuy". This means that if you increased your chips while sitting, those extra chips were "banked". Now, that\'s all changed! Each room will now remember your last chip stack, and when you sit down, that last amount will be used if it is more than a normal buy-in. This adds skill and excitement to the game, as you can\'t easily protect your winnings by standing up and sitting again. Players who built a big stack and then simply timed out will not be punished, as they can just sit again and resume playing that amount!'
    },
    {
        dateString: 'February 13, 2023',
        title: 'Improved Avatar Editor!',
        description: "The avatar editor is a lot simpler now, and visually shows options for each part, so you can more quickly get to the look you're going for! This will also make it easier to add and improve upon the parts later."
    },
    {
        dateString: 'February 15, 2023',
        title: 'Play Styles!',
        description: "This Power Player feature lets you see other players' play styles, such as how aggressive or loose they tend to play, so you can better adapt to their tendencies!",
        content: (_jsx("img", { css: css `
          border: 2px solid black;
        `, src: PLAY_STYLE_IMAGE_URL, alt: 'play style example', width: 322, height: 195 }))
    },
    {
        dateString: 'February 17, 2023',
        title: 'New Daily Tourney: High Roller Riot!',
        description: "Like to play higher stakes?! There's a new tourney that plays at 1PM CST every day. The buy-in is 200,000 chips. Tell your friends! (Tell your enemies too.)"
    },
    {
        dateString: 'February 23, 2023',
        title: 'Updates!',
        items: [
            "In Crazy Pineapple, when there is an all-in showdown prior to discarding, you no longer see everyone's cards.",
            'Omaha hand rendering can now wrap to two rows, which helps to keep them from being really small on smaller screen sizes.',
            'Improved the look of the sections in the Player Info and Self Info panels.',
            'Put a solid color background behind betting controls.'
        ]
    },
    {
        dateString: 'February 26, 2023',
        title: 'There are now two auto-betting buttons!',
        items: [
            '"Fold Any" means you will check if possible, otherwise fold at your next action.',
            '"Check" (as a small button shown when it is not your turn) means you will check if possible, otherwise do nothing at your next action.'
        ]
    },
    {
        dateString: 'March 1, 2023',
        title: 'Game Info pages are now accessible without logging in.',
        items: [
            _jsxs(_Fragment, { children: ["Check them out at", ' ', _jsx("a", { href: 'https://www.triplejack.com/poker/guide', target: '_blank', rel: 'noreferrer', children: "https://www.triplejack.com/poker/guide" })] })
        ]
    },
    {
        dateString: 'March 3, 2023',
        title: 'You can now set the room theme (table color and room background) from the Self Panel in a Poker room, so you can more easily see how each combination looks!'
    },
    {
        dateString: 'March 7, 2023',
        title: 'Updates!',
        items: [
            'Players with less than 2,500 Chips should now be able to sit at any regular table that has a minimum buy-in of 2,500 or less.',
            'Refresh button added to Player Info panel.',
            'New favicons added.'
        ]
    },
    {
        dateString: 'March 19, 2023',
        title: 'Medals features improved!',
        items: [
            'Now displaying some medals on seated players',
            'Medal graphics added to panels',
            'Info pages about medals added'
        ]
    },
    {
        dateString: 'March 22, 2023',
        title: "Medal images now show in the top section when viewing another player's info."
    },
    {
        dateString: 'March 28, 2023',
        title: 'Updates!',
        items: [
            'Medal images added for Old Timer, Cards In Space, Greedy Pig, and Monthly Finals! For Cards In Space and Greedy Pig, you need 10 wins of those tourneys for the medal to show up.',
            'Medals can now display in multiple columns on seated players!',
            'Large chip counts are now abbreviated in some places to save space!',
            'Added a new font for display of chips, pots, and player statuses on the table!'
        ]
    },
    {
        dateString: 'April 9, 2023',
        title: 'Updates!',
        items: [
            'Medal image added for players that win 10 High Roller Riot daily tourneys!',
            'Players that enter and leave MTT staging rooms are now shown in chat panel!',
            'Better responsive display of bet buttons on small screens!',
            'Improved button styling and colors!'
        ]
    },
    {
        dateString: 'April 12, 2023',
        title: 'Sheep bomb added! Use it when you get a b-a-a-a-a-d beat!',
        content: _jsx(NewsImageDisplay, { src: SHEEP_BUTTON_IMAGE_URL, maxWidthStyle: '75px', withBorder: false })
    },
    {
        dateString: 'April 15, 2023',
        title: 'Updates!',
        items: [
            'Added a "recoil" animation as a bomb is thrown!',
            'Simplified the bet slider to not show its own bet amount! When raising, the Raise button now shows the "Raise To" amount rather than a "Raise More" amount.'
        ]
    },
    {
        dateString: 'April 19, 2023',
        title: 'Rankings Lists added for Chips, Hands Played, and Insomniac! These lists are leaderboards of the top 25 active Power Players in each category!'
    },
    {
        dateString: 'April 22, 2023',
        title: 'Updates!',
        items: ['Chat bubbles now appear when a player chats something!', 'Three new room backgrounds are available!'],
        content: (_jsxs("div", { css: css `
          display: flex;
          flex-flow: row wrap;
          gap: 3px;
          img {
            border: 3px solid black;
          }
        `, children: [_jsx("img", { src: CHAT_BUBBLE_IMAGE_URL, width: 177, height: 175, alt: 'Chat Bubble' }), _jsx("img", { src: BLOBS_THUMB_IMAGE_URL, width: 100, height: 100, alt: 'Blobs 1 Background' }), _jsx("img", { src: BLOBS_2_THUMB_IMAGE_URL, width: 100, height: 100, alt: 'Blobs 2 Background' }), _jsx("img", { src: BLOBS_3_THUMB_IMAGE_URL, width: 100, height: 100, alt: 'Blobs 3 Background' })] }))
    },
    {
        dateString: 'May 3, 2023',
        title: 'You can now throw bombs and use charms from chat!',
        items: [
            'For example, "/pie Zen 2" will throw 2 pies at a player named "Zen" or starting with "Zen".',
            'See the Game Info page on "Chat Commands" for more info.'
        ]
    },
    {
        dateString: 'June 14, 2023',
        title: 'Win Unique Avatars!',
        content: (_jsxs("div", { children: ["Welcome to a new monthly competition where you can win a special, one-of-a-kind avatar that nobody else can own!", _jsx("p", {}), _jsxs("div", { css: css `
            display: flex;
            flex-flow: row wrap;
            align-items: center;
            gap: 3px;
            img {
              filter: drop-shadow(4px 4px 0 rgba(0, 0, 0, 0.2));
            }
          `, children: [_jsx("img", { src: MONKEY_AVATAR_THUMB_IMAGE_URL, width: 103, height: 106, alt: 'Unique Avatar' }), _jsx("img", { src: QUEEN_AVATAR_THUMB_IMAGE_URL, width: 129, height: 112, alt: 'Unique Avatar' }), _jsx("img", { src: SENTINEL_AVATAR_THUMB_IMAGE_URL, width: 74, height: 114, alt: 'Unique Avatar' }), _jsx("img", { src: WIZARD_AVATAR_THUMB_IMAGE_URL, width: 83, height: 109, alt: 'Unique Avatar' }), _jsx("img", { src: LIZARD_AVATAR_THUMB_IMAGE_URL, width: 119, height: 105, alt: 'Unique Avatar' })] }), _jsx("p", {}), "Power Players will be tracked in their activity in Regular (Non-Tourney) Texas Hold 'Em games with buy-ins of $2,500 and lower. The four most active players at the end of June will play a special tourney where the winner gets to pick one of five available unique avatars!", _jsx("p", {}), "For full details, see the Unique Avatars Game Info page!"] }))
    },
    {
        dateString: 'June 17, 2023',
        title: 'Give Chips Feature!',
        content: 'You can now give chips directly to another player! Note that chip amounts above 10,000 in a given month will be taxed at 20%.'
    },
    {
        dateString: 'June 21, 2023',
        title: 'Upcoming Jackpot Feature!',
        content: "A small amount of chips are taken from most pots now. It's not a tax, it's a rake for an exciting future jackpot feature, where you can see the jackpot grow and grow, and players will have a chance to win the jackpot. Stay tuned!"
    },
    {
        dateString: 'June 22, 2023',
        title: 'Unique Avatars Leaders!',
        content: (_jsxs("div", { children: ["There is ONE WEEK left in the inaugural competition to win a unique avatar that nobody else in the game can own or use! The top 4 players will play a special tourney where the winner gets to choose a unique avatar.", _jsx("br", {}), "Here are the current top 10 players in the running, IN RANDOM ORDER:", _jsx(RandomizingList, { items: [
                        'POKER_FLATS',
                        '_SIGBIN_',
                        'pocketnuts',
                        'Flat_Tire',
                        '10Dimes',
                        'grrrrrrrr',
                        '_Katsilog_',
                        '_KG_',
                        '__ZIG_ZAG__',
                        'kick_em'
                    ] }), "For full details, see the Unique Avatars Game Info page!"] }))
    },
    {
        dateString: 'June 30, 2023',
        title: 'Added a few more room backgrounds!'
    },
    {
        dateString: 'July 1, 2023',
        title: 'Unique Avatars Finalists!',
        content: (_jsxs("div", { children: ["The inaugural unique avatars competition has 4 finalists:", _jsxs("ul", { children: [_jsx("li", { children: "kick_em" }), _jsx("li", { children: "10Dimes" }), _jsx("li", { children: "Flat_Tire" }), _jsx("li", { children: "POKER_FLATS" })] }), "We will find a tourney time that works for all players in the next week or so. The winner of that tourney gets to choose a unique avatar to call their own!"] }))
    },
    {
        dateString: 'July 5, 2023',
        title: 'Chip Leader Indicator!',
        content: 'In MTTs (multi-table tournaments) there is now a green indicator on the chip leader, so you know who to play big pots against!'
    },
    {
        dateString: 'July 5, 2023',
        title: 'Unique Avatars Tourney!',
        content: 'The tourney time for the first unique avatar to be picked is Saturday July 8 at 10am CST. Come and watch kick_em, 10Dimes, Flat_Tire and POKER_FLATS battle it out! After that, a new unique avatars competition will start up!'
    },
    {
        dateString: 'July 8, 2023',
        title: 'Find your friends!',
        content: 'If you are friends with someone, there is now a menu action to find them, which will show if they are online and what room they are in!'
    },
    {
        dateString: 'July 8, 2023',
        title: 'kick_em wins first Unique Avatar!',
        content: (_jsxs(_Fragment, { children: ["After playing a lot of poker to be one of the 4 eligible players, kick_em took down the tourney and has a new avatar:", _jsx("p", {}), _jsx("img", { src: WIZARD_AVATAR_THUMB_IMAGE_URL, width: 83, height: 109, alt: 'Unique Avatar' }), _jsx("p", {}), "A new competition starts now, and four most active Power Players in low stakes Hold 'Em games between now and the end of July will compete in another tourney where the winner picks a unique avatar!"] }))
    },
    {
        dateString: 'July 20, 2023',
        title: 'Brick room backgrounds added!',
        content: (_jsxs(_Fragment, { children: ["Which one is your favorite?", _jsxs("div", { css: css `
            display: flex;
            flex-flow: row wrap;
            gap: 3px;
            img {
              border: 3px solid black;
            }
          `, children: [_jsx("img", { src: ALL_THEME_BACKGROUND_PROPERTIES.bricks.imageUrl, width: 100, height: 100, alt: 'Bricks 1 Background' }), _jsx("img", { src: ALL_THEME_BACKGROUND_PROPERTIES.bricks2.imageUrl, width: 100, height: 100, alt: 'Bricks 2 Background' }), _jsx("img", { src: ALL_THEME_BACKGROUND_PROPERTIES.bricks3.imageUrl, width: 100, height: 100, alt: 'Bricks 3 Background' }), _jsx("img", { src: ALL_THEME_BACKGROUND_PROPERTIES.bricks4.imageUrl, width: 100, height: 100, alt: 'Bricks 4 Background' })] })] }))
    },
    {
        dateString: 'August 1, 2023',
        title: 'Unique Avatars Finalists!',
        content: (_jsxs("div", { children: ["This month's unique avatars competition has 4 finalists:", _jsxs("ul", { children: [_jsx("li", { children: "shpg706" }), _jsx("li", { children: "POKER_FLATS" }), _jsx("li", { children: "_fishda_" }), _jsx("li", { children: "10Dimes" })] }), "We will find a tourney time that works for all players in the next week or so. The winner of that tourney gets to choose a unique avatar to call their own!"] }))
    },
    {
        dateString: 'August 4, 2023',
        title: 'Unique Avatars Tourney!',
        content: (_jsx("div", { children: "The Unique Avatars tourney for July will happen on August 5, 2023 at 11am CST. Come and watch / heckle / cheer on the players shpg706, POKER_FLATS, _fishda_ and 10Dimes as they try to win one of 5 unique avatars!" }))
    },
    {
        dateString: 'August 12, 2023',
        title: 'Updates!',
        items: [
            "shpg706 won July's Unique Avatars competition! The monthly race to win a one-of-a-kind avatar continues on and has already been going for August!",
            'A new Contact Us page has been added, use it to let us know your thoughts about Triplejack!'
        ]
    },
    {
        dateString: 'August 21, 2023',
        title: 'Lotsa Updates!',
        items: [
            "There's a new, easy-to-use Bombs & Charms panel! Drag and drop bombs onto seated players (or yourself) and set the number to use at one time!",
            'Improved graphics resolution and performance on mobile devices such as iPhone!',
            'Added a trash can bomb! Dump bins of junk on your opponents!',
            _jsxs(_Fragment, { children: ["Added a ", _jsx(EmphasisContainer, { children: "DEALIN'" }), " message at the start of each hand!"] }),
            "Panel buttons have a 'More Panels' menu if the screen is narrow enough that not all panels would fit.",
            'A bunch of minor UI improvements!'
        ]
    },
    {
        dateString: 'October 29, 2023',
        title: 'Updates!',
        items: [
            'In poker rooms, the "Room Info" panel has been split into separate "Room Info" and "Players" panels.',
            'Fixed issues with dragging bombs and charms out of the Bombs Panel on mobile devices.'
        ]
    },
    {
        dateString: 'November 18, 2023',
        title: 'Bad Beat Jackpot is here!',
        content: (_jsxs("div", { children: ["Have you ever lost with a hand that was so strong, you couldn't believe it? Well now you can win a HUGE amount of chips if you lose with a strong enough hand!", _jsxs("ul", { children: [_jsx("li", { children: "As of today, the full jackpot amount is over 32 MILLION chips!" }), _jsx("li", { children: "You must lose with a hand that is at least as strong as an Aces-over-Nines Full House, playing both cards in Texas Hold 'Em regular games." }), _jsx("li", { children: "Non-Power Players can only win 25% of the full jackpot amount." }), _jsx("li", { children: "The jackpot continually grows and will always have something in it!" })] })] }))
    },
    {
        dateString: 'November 27, 2023',
        title: 'Player Stats!',
        content: (_jsxs("div", { children: ["Power Players can now see some basic stats on themselves and other players, such as:", _jsxs("ul", { children: [_jsx("li", { children: "Number of Hands Played" }), _jsx("li", { children: "Number of Buy-ins" }), _jsx("li", { children: "Number of Triplejacks" }), _jsx("li", { children: "When the player was created" }), _jsx("li", { children: "When the player was last active" })] }), "More stats will be added over time!"] }))
    },
    {
        dateString: 'November 30, 2023',
        title: 'Tourney Win Sharing',
        content: (_jsx("div", { children: "If you win a tourney, you'll now see a 'Share Your Win' button for easy sharing to social media and your friends! Give it a try!" }))
    },
    {
        dateString: 'November 30, 2023',
        title: 'All-Insanity!',
        content: (_jsxs("div", { children: ["This new game type for Power Players reduces the strategy of poker to a single decision while making it more... insane! It plays like a regular game of Texas Hold 'Em except you only have two betting options: ALL-IN or FOLD. That's it!", _jsx("p", {}), "How many all-ins can you win in a row? How many multiples of your buy-in can you build up? The variance be crazy. Let's gooo!"] }))
    },
    {
        dateString: 'December 9, 2023',
        title: 'Updates!',
        items: [
            'Added Last Winner to Bad Beat Jackpot section in menu.',
            'Reduced max number of seats to 8 as an experiment for a while.',
            'Fixed a bug where revealing cards at end of showdown might take effect on the next hand.'
        ]
    },
    {
        dateString: 'December 14, 2023',
        title: 'Updates!',
        items: [
            'Added client version checking to detect when there is a version mismatch. If you see the message that your client is outdated, refresh/reload the game and on mobile you may need to force-close the app and re-open it.',
            'Chips rake in regular rooms now has a cap!'
        ]
    },
    {
        dateString: 'December 17, 2023',
        title: 'Spacing of seats improved to give a little more "elbow room"!'
    },
    {
        dateString: 'December 18, 2023',
        title: 'Updates!',
        items: ['Added cooler transition animation when moving between rooms!', 'Improved shading on room backgrounds!']
    },
    {
        dateString: 'December 20, 2023',
        title: 'Added Upcoming Tourneys list to the menu. It shows when each tourney series will run next! The list will periodically refresh itself if you keep it open, so you can monitor it.'
    },
    {
        dateString: 'December 31, 2023',
        title: 'Follow us on X/Twitter!',
        content: (_jsxs("div", { children: ["There will be more posts and activity on the", ' ', _jsx("a", { href: TWITTER_ACCOUNT_URL, target: '_blank', rel: 'noreferrer', children: "@Triplejack X/Twitter account" }), ", and maybe some special perks and opportunities for followers! Join us there!"] }))
    },
    {
        dateString: 'December 31, 2023',
        title: 'Another Bad Beat Jackpot Win!',
        content: (_jsx("div", { children: "Congratulations to marinedad25, a non-Power Player, who won a Bad Beat Jackpot worth over 14 MILLION chips! This was the second time a Bad Beat Jackpot was hit (the first was MrCdiddy88) since the feature launched! Good luck on the Hold 'Em tables and remember that Power Players can win the FULL jackpot amount!" }))
    },
    {
        dateString: 'January 1, 2024',
        title: 'Happy New Year!',
        content: (_jsx("div", { children: "We hope you have a fantastic and lucky 2024. Looking forward to a vibrant and fun community here. Thanks for playing Triplejack!" }))
    },
    {
        dateString: 'January 1, 2024',
        title: 'Unique Avatars Competition Returns!',
        content: (_jsx("div", { children: "The Unique Avatars Competition is back on for January! The top 4 Power Players that play a lot of low stakes Hold 'Em rooms will play in a finals tourney to win a unique avatar that nobody else owns!" }))
    },
    {
        dateString: 'January 27, 2024',
        title: "Rake reduced in non-Texas Hold 'Em games!"
    },
    {
        dateString: 'January 28, 2024',
        title: 'Updates!',
        items: [
            'Action players are now animated with a subtle "head bob" animation!',
            'The header bar is now red in tourney rooms to make it clearer at a glance when in a tourney vs. a regular room!',
            'Improved layout and color coded the Upcoming Tourneys list!'
        ]
    },
    {
        dateString: 'February 3, 2024',
        title: 'Unique Avatars Finalists!',
        content: (_jsxs("div", { children: ["The Unique Avatars competition came back last month! Here are the top 4 players who will play a special tourney where the winner gets to choose a unique avatar! Stay tuned and check the Upcoming Tourneys list to see when the tourney will happen!", _jsx("br", {}), _jsxs("ul", { children: [_jsx("li", { children: "Unlucky_player" }), _jsx("li", { children: "TG_IVORY" }), _jsx("li", { children: "S_t_a_c_k_s" }), _jsx("li", { children: "__CLOUD__" })] }), "For full details, see the Unique Avatars Game Info page!"] }))
    },
    {
        dateString: 'February 12, 2024',
        title: 'Updates!',
        items: [
            "There's a Newest Players list you can find in the 'Players' section of the menu. Please give a warm welcome to newcomers in our community, they are important for our growth!",
            'Email notifications of direct messages have been redesigned!'
        ]
    },
    {
        dateString: 'February 22, 2024',
        title: '10 MILLION CHIP TOURNEY!',
        content: (_jsxs("div", { children: ["This Saturday (Feb 24) at 9AM CST will be the biggest 1st place prize in the history of Triplejack! Come play the BIG CHIP CHASER!", _jsx("br", {}), _jsxs("ul", { children: [_jsx("li", { children: "Must be Power Player to play!" }), _jsx("li", { children: "Only 500 chip buy-in!" }), _jsx("li", { children: "Bonus 10,000,000 Chips to 1st place!" })] })] }))
    },
    {
        dateString: 'March 9, 2024',
        title: 'Updates!',
        items: ['Max number of seats for regular games bumped back up to 11!', 'Improved graphics of suits on cards!']
    },
    {
        dateString: 'March 9, 2024',
        title: 'Side Betting Features are here!',
        content: (_jsxs("div", { children: ["Side betting is a fun game to play alongside poker, where you can wager Jacks on a player you think will win the current hand! You can side bet on hands you aren't active in (including hands you ", _jsx("em", { children: "were" }), " active in, but already folded).", _jsx("p", {}), _jsx("strong", { css: css `
            color: ${YELLOW_COLOR};
          `, children: "NOTE: You must turn on \"Side Betting\" in your Settings to use the feature!" }), _jsx("p", {}), "At the end of the hand, all player(s) that side bet on a winner will split the side bet pot.", _jsx("p", {}), "See the Game Info page about Side Bets for more info, and have fun!"] }))
    },
    {
        dateString: 'March 14, 2024',
        title: 'Side Betting Improvements!',
        items: [
            "Blue dots will show up under a player's name, indicating how many side bets are currently on them!",
            'Side bet stats are starting at zero, and stats can now be seen on your self stats or on other players (if you are a Power Player)!',
            'You can now side bet in tourneys!',
            'Minor fixes and improvements.'
        ]
    },
    {
        dateString: 'March 24, 2024',
        title: 'More Side Betting Improvements!',
        items: [
            "Side bettors now have a button that appears below the table if they are sitting and can place a side bet at that time. Usually this button will appear after you've folded and others are still in the hand!",
            "Rankings and medals for 'Side Bets Won' and 'Side Bets Profit' are now live!",
            'A new animation appears when selecting a side bet target that highlights any valid players to side bet on!'
        ]
    },
    {
        dateString: 'March 26, 2024',
        title: 'Side Bet Summaries Improved in History Panel!'
    },
    {
        dateString: 'March 28, 2024',
        title: 'Side Bet dots under player names now are colored to indicate which side bets were winners, losers, and refunded.'
    },
    {
        dateString: 'April 3, 2024',
        title: 'Updates!',
        items: [
            'The Side Bets panel now shows a full list of each side bet that is placed, and who placed it!',
            'Side bet animations now show who placed the side bet!',
            'New players are now announced when they log in for the first time. Please welcome them and help them get going on the site, it helps us grow and become a better site every time a new player becomes a regular!',
            'Side bet phases are now slightly longer to allow more time for side bets to be placed!',
            'Animations have been improved in a number of places!'
        ]
    },
    {
        dateString: 'April 20, 2024',
        title: 'Updates!',
        items: [
            'Upgraded the artwork for all table theme colors!',
            'Added red, green, and blue accent colors to betting buttons!'
        ]
    },
    {
        dateString: 'August 9, 2024',
        title: 'Dual Limits!',
        description: 'Hold \'Em and Crazy Pineapple games can now be played "Dual Limit" which means Pot Limit Pre-Flop and on the Flop, and No Limit after that! This variant allows more measured play than pure No Limit. Dual Limit is available on regular (non-tourney) games and is auto-enabled at low stakes. This feature takes the place of the Aggro Betting Filter. Enjoy!'
    },
    {
        dateString: 'October 5, 2024',
        title: 'Updates!',
        items: [
            'Giving chips to another player now costs 500 Jacks per transfer, but the chip "tax" on transfers has been removed.',
            'The Daily Free Jacks tourneys now require 25 non-tourney hands to be played in the 24 hours prior to the start of the tourney. Note that hands that finish quickly may not count towards this requirement. There will also be spur-of-the-moment tourneys with potentially large bonuses for the winner, that will also require recent activity to play!',
            'A while back, I added an "avatar generation service" which means the player avatars are now being generated on a server rather than on your computer. If you sometimes had problems with the game crashing, in particular soon after entering a room, this may have fixed it for you!'
        ]
    },
    {
        dateString: 'October 27, 2024',
        title: 'Updates!',
        items: [
            'The 50K Chip Bonus Game now pays 100K to the winner and has been renamed!',
            'Power Players can now see how many hands they have recently played (in the Stats section of the Self panel). As more tourneys may require a certain number of recent hands played, you can check this info to see if you need to play more hands.',
            'The "Game Info" pages have been renamed to the "Game Guide".'
        ]
    },
    {
        dateString: 'November 17, 2024',
        title: '10 Million Chip tourney!',
        description: 'There will be a SUPER MILLIONS tourney on Nov 18 at 8AM CST. 1st place will get $10,000,000 chips! In order to play you need to have played 50 hands in the 24 hours before the game starts! Good luck!'
    },
    {
        dateString: 'November 20, 2024',
        title: 'Bad Beat Requirements Adjusted',
        description: 'The requirement for the losing player in a bad beat jackpot hand was reduced slightly from AAA99 to AAA88. Note that kickers still are ineligible for a bad beat hand. Generally, this means that if the hand is quads, the player must have a pocket pair, and not one matching card and a kicker.'
    },
    {
        dateString: 'December 16, 2024',
        title: 'Updates!',
        items: [
            "Triplejack uses a graphics library called pixi.js which has been upgraded! The game will run smoother for most players. If you notice any issues, make sure you're running the latest version of Google Chrome or a Chromium-based browser. Direct message ZenBlender or use the Contact Us button about any new problems you see!",
            'Starting chips and rebuy chips have been increased!',
            'Panels now show a little sliding animation when they are shown!'
        ]
    },
    // {
    //   dateString: 'January 1, 2025',
    //   title: 'Happy New Year!',
    //   items: [
    //     "Thanks for being a part of the Triplejack community this past year! 2025 will be another good one for the site, with many planned improvements on the way! Let's keep it goin!",
    //     'The panels can now display on the right or the top side of the screen! This is especially nice on mobile devices where there is not much room for the panels on the right when the device is held vertically. In this case, the panel moves to the top of the screen. To give you more control over this, there is now a Setting you can switch from "Auto" (the default) to the side you prefer. This setting is per-device, as some people may prefer one setting on mobile and another on a computer.'
    //   ]
    // }
    {
        dateString: 'January 12, 2025',
        title: 'Volume Slider!',
        description: "We now have a volume 🔊 slider 🎚️! I know the people in your building love to hear the sounds of Triplejack bombs 💣 and pies 🥧 literally shaking 🫨 the room at all hours, but in case they don't, you can now turn it down a little bit. 🤣"
    },
    {
        dateString: 'January 15, 2025',
        title: 'Show Chips as Big Blind Multiple!',
        description: 'This new Power Player setting affects how chips in play are shown. When on, it\'ll display as a multiple of the big blind with the "bb" suffix. Some players like this, and prefer it in tourneys.'
    },
    {
        dateString: 'January 18, 2025',
        title: 'Power Players get more starting chips in tourneys!',
        description: "If you're a Power Player, you'll now get more starting chips 💰 in most scheduled tourneys! Typically, a Power Player will get 50% more chips than a non-Power Player 🚀. It doesn't affect the payouts or prize pool, but having more chips improves your chances 🍀 of winning! Some tourneys will still give the same starting chips to all players."
    },
    {
        dateString: 'January 25, 2025',
        title: 'New Contact Us Feature!',
        description: 'There is a new Contact Us ✉️ option in the menu, where you can send a message to the person who runs this whole thing. Please use this to give feedback or a suggestion on the site, report a problem or bug, ask a question, or just say hi! I really appreciate your input!'
    },
    {
        dateString: 'January 29, 2025',
        title: 'Direct Messages have been redesigned and look a lot better now!'
    }
];
